"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_table_1 = require("react-table");
var loader_1 = require("../loader/loader");
require("../table.css");
var reactstrap_1 = require("reactstrap");
var AppTable = function (props) {
    //const columnData = useMemo(() => columns, [columns]);
    //const rowData = useMemo(() => data, [data]);
    var columns = props.columns;
    var data = props.data;
    var isLoading = props.isloading;
    var _a = (0, react_table_1.useTable)({
        columns: columns,
        data: data,
        manualPagination: false
    }), getTableProps = _a.getTableProps, getTableBodyProps = _a.getTableBodyProps, headerGroups = _a.headerGroups, rows = _a.rows, prepareRow = _a.prepareRow;
    return (React.createElement(React.Fragment, null, isLoading ? (React.createElement(loader_1.default, null)) : (React.createElement(reactstrap_1.Table, __assign({}, getTableProps()),
        React.createElement("thead", null, headerGroups.map(function (headerGroup) { return (React.createElement("tr", __assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) { return (React.createElement("th", __assign({}, column.getHeaderProps()), column.render("Header"))); }))); })),
        React.createElement("tbody", __assign({}, getTableBodyProps()), rows.map(function (row, i) {
            prepareRow(row);
            return (React.createElement("tr", __assign({}, row.getRowProps()), row.cells.map(function (cell) {
                return React.createElement("td", __assign({}, cell.getCellProps()), cell.render("Cell"));
            })));
        }))))));
};
exports.default = AppTable;
//# sourceMappingURL=table.js.map